import { render } from "./Lottie.vue?vue&type=template&id=7640a6c2"
import script from "./Lottie.vue?vue&type=script&lang=js"
export * from "./Lottie.vue?vue&type=script&lang=js"

import "./Lottie.vue?vue&type=style&index=0&id=7640a6c2&lang=scss"

import exportComponent from "/var/www/sites/qiyas.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__